<template>
  <div>
    <div class="pc">
      <div class="content">
        <div class="main">
          <img class="logo" @click="skip('/')" src="@/assets/pcImg/logo-white.png" alt="" />

          <div class="card">
            <div class="title">पंजीकरण</div>
            <input
              type="text"
              placeholder="इमेल आईडी"
              v-model="registerForm.userName"
              @blur="checkRegisted"
            />
            <input
              type="text"
              maxlength="4"
              placeholder="परीक्षण कोड"
              v-model="registerForm.verifyCode"
            />
            <button class="send" :disabled="!canClick" @click="getVerifyCode">
              {{ canClick ? $t("rigisterPage.form.getYanzhengma") : content }}
            </button>
            <input
              :type="pcType"
              placeholder="पासवर्ड"
              v-model="registerForm.password"
            />
            <img
              class="password-close"
              @click="changeType('pc')"
              :src="pcPassword"
              alt=""
            />
            <input
              :type="pcConType"
              placeholder="पासवर्ड पुष्टि करें"
              v-model="registerForm.confirmedPassword"
            />
            <img
              class="confirm-close"
              @click="changeType('pcc')"
              :src="pcConfirm"
              alt=""
            />
            <div class="sign-up" @click="onSubmit">पंजीकरण</div>
            <div class="agree">
              <div
                :class="checked ? 'box bgcolor' : 'box'"
                @click="checked = !checked"
              >
                <img
                  v-if="checked"
                  class="check"
                  src="@/assets/pcImg/check.png"
                  alt=""
                />
              </div>
              <p>
                <span @click="skip('/privacyClauses/1')"> मैं शर्तों और नियमों से सहमत हूं</span>
                <span @click="skip('/privacyClauses/2')"> गोपनीयता नीति</span>
              </p>
            </div>
          </div>

          <div class="foot">
            <div class="info">
              <div @click="skip('/privacyClauses/1')">उपयोग की शर्तें</div>
              <div @click="skip('/privacyClauses/2')">गोपनीयता नीति</div>
              <div @click="skip('/aboutQuestionnaire')">कैसे उपयोग करें</div>
              <div @click="skip('/helpFeedback')">
                अक्सर पूछे जाने वाले प्रश्न
              </div>
            </div>
            <div class="copyright">copyright@2023@weopinions.com</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile">
      <div class="mobile-content">
        <div class="mobile-main">
          <div class="imgs">
            <img
              class="fallback"
              @click="goback"
              src="@/assets/pcImg/fallback.png"
              alt=""
            />
            <img class="logo" @click="skip('/')"  src="@/assets/pcImg/logo-white.png" alt="" />
          </div>
          <div class="text">पंजीकरण</div>
          <div class="text">हैलो!</div>
          <div class="inputs">
            <div class="line-input">
              <img
                class="input-icon"
                src="@/assets/pcImg/emali.png"
                alt="图标"
              />
              <input
                type="text"
                v-model="registerForm.userName"
                placeholder="इमेल"
              />
            </div>
            <div class="line-input">
              <img
                class="input-icon"
                src="@/assets/pcImg/code.png"
                alt="图标"
              />
              <input
                maxlength="4"
                type="text"
                v-model="registerForm.verifyCode"
                placeholder="परीक्षण कोड"
              />
              <button class="send" :disabled="!canClick" @click="getVerifyCode">
                {{ canClick ? $t("rigisterPage.form.getYanzhengma") : content }}
              </button>
            </div>
            <div class="line-input">
              <img
                class="input-icon"
                src="@/assets/pcImg/Password.png"
                alt="图标"
              />
              <input
                :type="moType"
                v-model="registerForm.password"
                placeholder="पासवर्ड"
              />
              <img
                class="eye-icon"
                @click="changeType('mo')"
                :src="moPassword"
                alt="图标"
              />
            </div>
            <div class="line-input">
              <img
                class="input-icon"
                src="@/assets/pcImg/Password.png"
                alt="图标"
              />
              <input
                v-model="registerForm.confirmedPassword"
                :type="moConType"
                placeholder="पासवर्ड पुष्टि करें"
              />
              <img
                class="eye-icon"
                :src="moConfirm"
                @click="changeType('moc')"
                alt="图标"
              />
            </div>
          </div>
          <button class="submit" @click="onSubmit">सबमिट करें</button>
          <div class="agree">
            <div
              :class="checked ? 'box bgcolor' : 'box'"
              @click="checked = !checked"
            >
              <img
                v-if="checked"
                class="check"
                src="@/assets/pcImg/check.png"
                alt=""
              />
            </div>
            <p>
              <span @click="skip('/privacyClauses/1')"> मैं शर्तों और नियमों से सहमत हूं</span>
              <span @click="skip('/privacyClauses/2')"> गोपनीयता नीति</span>
            </p>
          </div>
        </div>

        <div class="mobile-foot">
          <div @click="skip('/privacyClauses/1')">उपयोग की शर्तें</div>
          <div @click="skip('/privacyClauses/2')">निजी नीति</div>
          <div @click="skip('/aboutQuestionnaire')">कैसे उपयोग करें</div>
          <div @click="skip('/helpFeedback')">अक्सर पूछे जाने वाले प्रश्न</div>
          <div class="mobile-copyright">copyright@2023@weopinions.com</div>
        </div>
      </div>
    </div>
    <div class="mask"></div>
  </div>
</template>
<script>
import { Notify } from "vant";
import { registryCode, registered, registry } from "@/api/api.js";
export default {
  data() {
    return {
      checked: false,
      pcPassword: require("@/assets/pcImg/close.png"),
      pcType: "password",
      pcConfirm: require("@/assets/pcImg/close.png"),
      pcConType: "password",
      moPassword: require("@/assets/pcImg/close-eyes.png"),
      moType: "password",
      moConfirm: require("@/assets/pcImg/close-eyes.png"),
      moConType: "password",
      registerForm: {
        userName: "",
        verifyCode: "",
        password: "",
        confirmedPassword: "",
        recommendedCode: "",
        channelCode: "",
        keyOfChannel: "",
        deviceID: "",
        deviceType: "",
        fingerprintCode: "",
      },
      content: this.$t("rigisterPage.form.getYanzhengma"), // 按钮里显示的内容
      totalTime: 60, // 记录具体倒计时时间
      canClick: true, // 添加canClick
      clock: null,
    };
  },
  methods: {
    // 跳转
    skip(url) {
      this.$router.push({
        path: url,
      });
    },
    goback() {
      this.$router.go(-1);
    },
    // 修改input type
    changeType(type) {
      switch (type) {
        case "pc":
          if (this.pcType === "password") {
            this.pcType = "text";
            this.pcPassword = require("@/assets/pcImg/open.png");

            return;
          }
          if (this.pcType === "text") {
            this.pcType = "password";
            this.pcPassword = require("@/assets/pcImg/close.png");
            return;
          }
          break;
        case "pcc":
          if (this.pcConType === "password") {
            this.pcConType = "text";
            this.pcConfirm = require("@/assets/pcImg/open.png");
            return;
          }
          if (this.pcConType === "text") {
            this.pcConType = "password";
            this.pcConfirm = require("@/assets/pcImg/close.png");
            return;
          }
          break;
        case "mo":
          if (this.moType === "password") {
            this.moType = "text";
            this.moPassword = require("@/assets/pcImg/open-eyes.png");

            return;
          }
          if (this.moType === "text") {
            this.moType = "password";
            this.moPassword = require("@/assets/pcImg/close-eyes.png");
            return;
          }
          break;
        case "moc":
          if (this.moConType === "password") {
            this.moConType = "text";
            this.moConfirm = require("@/assets/pcImg/open-eyes.png");

            return;
          }
          if (this.moConType === "text") {
            this.moConType = "password";
            this.moConfirm = require("@/assets/pcImg/close-eyes.png");
            return;
          }
          break;
        default:
          break;
      }
    },
    // 验证邮箱是否注册
    async checkRegisted() {
      if (!this.registerForm.userName) {
        Notify({ type: "warning", message: this.$t("inputEmail") });
        return;
      } else {
        let params = { userName: this.registerForm.userName };
        await registered(params).then((res) => {
          if (res.code !== 200) {
            Notify({ type: "warning", message: res.errors[0] });
          }
        });
      }
    },
    setTime() {
      if (!this.canClick) return; // 如果是false 直接return出去
      this.canClick = false;

      this.content = this.$t("rigisterPage.timeTick").replace(
        "{0}",
        this.totalTime
      );

      this.clock = window.setInterval(() => {
        this.totalTime--;
        this.content = this.$t("rigisterPage.timeTick").replace(
          "{0}",
          this.totalTime
        );

        if (this.totalTime < 0) {
          window.clearInterval(this.clock);
          this.content = this.$t("sendVerfAgain");
          this.totalTime = 60;
          this.canClick = true; // 这里重新开启
        }
      }, 1000);
    },
    // 获取验证码
    async getVerifyCode() {
      if (!this.registerForm.userName) {
        Notify({ type: "warning", message: this.$t("inputEmail") });
        return;
      }
      this.setTime();
      let params = {
        userName: this.registerForm.userName,
        challenge: "",
        validate: "",
        seccode: "",
      };
      registryCode(params).then((res) => {
        if (res.code === 200) {
          this.verifyCodeTag = true;
          Notify({ type: "primary", message: this.$t("alreadySend") });
        } else {
          window.clearInterval(this.clock);
          this.totalTime = 60;
          this.canClick = true;
          this.verifyCodeTag = false;
          Notify({ type: "warning", message: res.errors[0] });
        }
      });
    },
    async onSubmit() {
      //获取本地存储的推荐人信息
      let recommendedInfo = window.sessionStorage.getItem("recommendedInfo");
      if (recommendedInfo !== null) {
        recommendedInfo = JSON.parse(recommendedInfo);
        Object.assign(this.registerForm, recommendedInfo);
      }
      //判断是否同意隐私条例
      if (!this.checked) {
        Notify({
          type: "primary",
          message: "Please select the privacy policy",
        });
        return;
      }
      await registry(this.registerForm).then((res) => {
        if (res.code === 200) {
          Notify({
            type: "primary",
            message: this.$t("rigisterPage.registerSuccessed"),
          });
          this.$router.push({
            path: "/",
          });
        } else {
          Notify({ type: "primary", message: res.errors[0] });
        }
      });
    },
  },
  created() {
    // 判断是否是全屏显示
    console.log(1111, localStorage.getItem("questionnaireItem"));
    setTimeout(() => {
      if (
        localStorage.getItem("questionnaireItem") == 0 ||
        !localStorage.getItem("questionnaireItem")
      ) {
        localStorage.setItem("questionnaireItem", 1);
        //this.$router.go(0);
      }
    }, 100);
    // 修改title
    document.title='Have your say with Weopinions | Collect points for Free Online Surveys description: Weopinions is a market research panel where members collect points for their opinions in free online surveys. Sign up now.'
  },
  beforeDestroy() {
    localStorage.setItem("questionnaireItem", 0);
  },
};
</script>
<style scoped>
/*pc端 */
.content {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  background-image: url("../assets/pcImg/bg.jpg");
  background-size: cover;
  background-position: 50% 70%;
}
.mask {
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9;
}
.main {
  position: relative;
  width: 100%;
  z-index: 99;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.logo {
  width: 180.625px;
  height: 35.625px;
  margin-top: 82.5px;
  cursor: pointer;
}
.card {
  position: relative;
  width: 187.5px;
  height: 301.875px;
  padding-left: 43.5px;
  padding-right: 43.75px;
  background: #ffffff;
  border-radius: 6.25px;
  margin-top: 32.5px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.card .title {
  font-size: 15px;
  font-weight: 500;
  color: #232323;
  margin-top: 21.25px;
}
.card input {
  width: calc(100% - 54.25px);
  height: 25px;
  opacity: 1;
  border: 0.625px solid #dddddd;
  margin-top: 15.625px;
  padding-left: 16.25px;
  padding-right: 38px;
  font-size: 10px;
  font-weight: 400;
  color: #999999;
}
.card .send {
  position: absolute;
  top: 101px;
  right: 52.5px;
  font-size: 10px;
  font-weight: 400;
  color: #2e67ea;
  background-color: #fff;
  width: 80px;
  padding: 0;
  text-align: right;
}
.card .password-close {
  position: absolute;
  width: 15px;
  height: 15px;
  top: 143px;
  right: 50.625px;
  cursor: pointer;
}
.card .confirm-close {
  position: absolute;
  width: 15px;
  height: 15px;
  top: 183px;
  right: 50.625px;
  cursor: pointer;
}
.card button {
  width: 100%;
  margin: 0;
  padding: 0;
}
.sign-up {
  width: 100%;
  height: 25px;
  border-radius: 25px;
  line-height: 25px;
  background-color: #2e67ea;
  text-align: center;
  color: #fff;
  font-size: 10px;
  margin-top: 20px;
  cursor: pointer;
}
.agree {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  font-size: 8.75px;
  margin-top: 18.75px;
}
.agree > .box {
  width: 9.375px;
  height: 9.375px;
  background-color: #fff;
  border-radius: 2px;
  margin-right: 10.625px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0.625px solid #999;
}
.agree > .bgcolor {
  background-color: #2e67ea;
  border: 0.625px solid #2e67ea;
}
.check {
  width: 5px;
  height: 5px;
}
.agree > p {
  cursor: pointer;
}

/* 页脚 */
.foot {
  margin-top: 71.875px;
  margin-bottom: 24.375px;
  font-size: 8.75px;
  color: #fff;
}
.foot > .info {
  display: flex;
}
.info > div {
  border-right: 1px solid #fff;
  padding-right: 21.25px;
  padding-left: 21.25px;
}
.info > div:last-child {
  border-right: none;
}
.copyright {
  width: 100%;
  text-align: center;
  margin-top: 17.5px;
}
</style>
<style scoped>
/* 移动端 */
.mobile {
  display: none;
}

.mobile-content {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  background-image: url("../assets/pcImg/bg.jpg");
  background-size: cover;
  background-position: 50% 70%;
}
.mobile-main {
  position: relative;
  width: 100%;
  z-index: 99;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mobile-main > .imgs {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 27.5px;
  margin-bottom: 73.75px;
}
.mobile-main > .imgs > .fallback {
  position: absolute;
  left: 18.75px;
  width: 25px;
  height: 25px;
  cursor: pointer;
}
.mobile-main > .imgs > .logo {
  margin: 0 auto;
  width: 232.5px;
  height: 46.25px;
}
.mobile-main > .text {
  width: calc(100% - 45px);
  font-size: 30px;
  color: #ffffff;
  margin-left: 22.5px;
  margin-bottom: 20px;
}
.inputs {
  width: calc(100% - 45px);
  margin-left: 22.5px;
  /* margin-right: 22.5px; */
}
.line-input {
  width: 100%;
  position: relative;
  margin-top: 10px;
}
.line-input > input {
  width: calc(100% - 137.5px);
  height: 50px;
  padding-left: 75px;
  padding-right: 40px;
  font-size: 17.5px;
  color: #999999;
}
.line-input .input-icon {
  position: relative;
  top: 39px;
  left: 20px;
  width: 25px;
  display: block;
}
.line-input .eye-icon {
  position: absolute;
  top: 39px;
  right: 30px;
  width: 25px;
  display: block;
  cursor: pointer;
}
.mobile-main .submit {
  width: calc(100% - 67.5px);
  height: 50px;
  background-color: #3d66e2;
  color: #fff;
  font-size: 17.5px;
  border-radius: 50px;
  margin-top: 41.25px;
  cursor: pointer;
}
.mobile-main .agree {
  width: calc(100% - 35px);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 15px;
  color: #fff;
  margin-top: 21.25px;
  margin-left: 35px;
}
.mobile-main > .agree > .box {
  width: 14px;
  height: 14px;
  background-color: #fff;
  border-radius: 2px;
  margin-right: 10.625px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mobile-main > .agree > .bgcolor {
  width: 14px;
  height: 14px;
  background-color: #2e67ea;
  border-radius: 2px;
  margin-right: 10.625px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mobile-main > .agree > .box > .check {
  width: 8.5px;
  height: 8.5px;
  border-radius: 2px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mobile-foot {
  position: relative;
  width: 100%;
  text-align: center;
  color: #fff;
  font-size: 15px;
  z-index: 999;
  margin-top: 95px;
  padding-bottom: 9.375px;
}
.mobile-foot > div {
  margin-bottom: 11.25px;
  cursor: pointer;
}
.mobile-copyright {
  margin-top: 51.25px;
}
.line-input > .send {
  position: absolute;
  min-width: 50px;
  right: 30px;
  padding: 0;
  margin: 0;
  background-color: #fff;
  height: 50px;
  color: #3d66e2;
  font-size: 17.5px;
  text-align: right;
}
</style>
<style scoped>
/* 媒体查询 */
@media only screen and (max-width: 768px) {
  .pc {
    display: none;
  }
  .mobile {
    display: block;
  }
}
/* 兼容 */
input::-ms-reveal {
  display: none;
}
input::-ms-clear {
  display: none;
}
input::-o-clear {
  display: none;
}

button {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/logon.vue